import axios from 'axios'
import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {SignupForm} from '../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {ENV} from '../Utils/_helpers/EnvHelper'
import {resetRedux} from '../Redux/store'
import { fetchAsyncUserDetails } from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

const ThirdPartySignupForm = () => {
  const API_URL = ENV().REACT_APP_API_URL
  const param = useLocation()
  const searchParams = new URLSearchParams(param.search)
  const AUTHTOKEN = searchParams.get('etoken')
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    const autoLogin = async () => {
      try {
        const res = await axios.post(`${API_URL}/auth/user/autoLogin`, { external_token: AUTHTOKEN })
        dispatch(resetRedux())
        dispatch(SignupForm(res?.data?.data))

        if (res.data.status) {
          const userData = res?.data?.data?.user
          const isBcardUser = userData?.tagNames?.includes('B-card') && userData?.features?.includes('Wallet Card')
          const isOwner = userData?.role === 'owner'
          
          const navigateTo = isBcardUser && isOwner ? '/wallet-card/subscription' : '/onboarding'
          navigate(navigateTo)
        } else {
          navigate('/auth')
        }
      } catch (error) {
        console.error('Auto-login error:', error)
      }
    }

    autoLogin()
  }, [])

  return <></>
}

export default ThirdPartySignupForm
